import { useState, useCallback } from 'react';

const useFileUploadQueue = () => {
    const [queue, setQueue] = useState<File[]>([]);

    const addFilesToQueue = useCallback((files: File[]) => {
        if (!files?.length)
            return;
        setQueue(q => [...q, ...files]);
    }, [setQueue]);

    const getFileQueue = useCallback(() => queue, [queue]);

    const clearFileQueue = useCallback(() => {
        setQueue([]);
    }, []);

    return {
        addFilesToQueue,
        getFileQueue,
        clearFileQueue
    };
};
export default useFileUploadQueue;